import { Injectable } from "@angular/core";
import { NGXLogger as LoggerService } from "ngx-logger";
import { RouteContextService } from "../../shared/services/route-context.service";
import { AuthService } from "../../user/auth.service";
import { ResponsiveService } from "../../shared/services/responsive.service";
import { CurrentPollService } from "../../whoo/core/current-poll.service";
import { TemplateService } from "../../whoo/core/poll-templates/template.service";
import { HeaderOrTemplateService } from "../../whoo/shared/poll-templates/header-or-template.service";

@Injectable({
    providedIn: 'root'
})

export class AppShellService {
    constructor(
        private logger: LoggerService,
        public routeContextService: RouteContextService,
        public authService: AuthService,
        public responsiveService: ResponsiveService,
        public currentPollService: CurrentPollService,
        public templateService: TemplateService,
        private headerOrTemplateService: HeaderOrTemplateService) {
    }

    get isStepper() {
        if (this.routeContextService.id === 'editPoll' || this.routeContextService.id === 'createPoll') return true
    }

    /**
     * True wenn die aktuelle Route eine Sample-Poll-Page ist (Detail oder Matrix).
     * Wird vom whoo-app-Wrapper als CSS-Klasse genutzt, um den Sample-Banner
     * als Overlay statt im Flow zu rendern — sonst wuerde er das Background-Image
     * unter die Navbar druecken.
     */
    get isSamplePollRoute(): boolean {
        return this.routeContextService.id === 'samplePoll'
            || this.routeContextService.id === 'samplePollMatrix';
    }

    get showNavBarInWhooApp() {
        if (this.routeContextService.id === 'choosePollTemplate'
            || this.routeContextService.id === 'editPoll'
            || this.routeContextService.id === 'createPoll') {
            return false;
        }
        return (!this.getShowContextBar() && !this.showVoteBarInWhooAppInvite && !this.showVoteBarInWhooApp)
    }

    get showVoteBarInWhooApp() {
        return (
            this.routeContextService.id === 'vote'
            || this.routeContextService.id === 'voteResponse'
            || this.routeContextService.id === 'pollMatrix'
            || this.routeContextService.id === 'samplePoll'
            || this.routeContextService.id === 'samplePollMatrix'

        )
            && !this.isInvitation
    }
    get showVoteBarInWhooAppInvite() {
        return (
            this.routeContextService.id === 'vote'
            || this.routeContextService.id === 'voteResponse'
            || this.routeContextService.id === 'pollMatrix'
            || this.routeContextService.id === 'samplePoll'
            || this.routeContextService.id === 'samplePollMatrix'
        )
            && this.isInvitation
    }

    get isInvitation() {
        return this.headerOrTemplateService.getFormToUse() === 'invitation'

    }
    public getShowContextBar(): boolean {
        if (this.routeContextService.id === 'pollResponses' ||
            this.routeContextService.id === 'votePreview' ||
            this.routeContextService.id === 'votePreviewResponse') {
            return true
        }
        return false
    }

    public getShowBanner(): boolean {
        if (
            this.routeContextService.id === 'editPoll' ||
            this.routeContextService.id === 'createPoll' ||
            this.routeContextService.id === 'vote' ||
            this.routeContextService.id === 'votePreview' ||
            this.routeContextService.id === 'voteResponse' ||
            this.routeContextService.id === 'votePreviewResponse') {
            return false
        }
        return true
    }

    get showFeedbackButton(): boolean {
        if (this.responsiveService.isScreenBelowMedium()) {
            return false;
        } else {
            if (this.routeContextService.id !== 'editPoll' &&
                this.routeContextService.id !== 'votePreview' &&
                this.routeContextService.id !== 'vote' &&
                this.routeContextService.id !== 'votePreviewResponse' &&
                this.routeContextService.id !== 'voteResponse' &&
                this.routeContextService.id !== 'samplePoll' &&
                this.routeContextService.id !== 'samplePollMatrix'
            ) {
                return true
            }
            return false

        }
    }


}


